import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    typography: {
        fontSize: 14,
    },
    palette: {
        primary: {
            main: '#4FB8D8',
        },
        secondary: {
            main: '#44338A',
        },
    },
});

export default theme;
